(function (angular, app) {
    'use strict';

    app.directive('partialRedemptionGroupInput', [function () {
	return {
		restrict: 'E',
		templateUrl: 'template/directives/loyalty/partial-redemption-group-input/index.html',
		replace: true,
		scope: {
			spModel: '=',
			spMax: '=',
			spClick: '&',
			spKeyUp: '&',
			buttonText: '@',
			buttonTextColor: '@',
			buttonBackgroundColor: '@'
		},
		controller: [
			'$scope',
			function ($scope) {
                $scope.validateRedeemInput = function(event) {
                    var key = event.key;
                    var isDigit = /\d/.test(key);
                    var isSpecialKey = [
                      "Backspace",
                      "Delete",
                      "Tab",
                      "Escape",
                      "Enter",
                      "Home",
                      "End",
                      "ArrowLeft",
                      "ArrowUp",
                      "ArrowRight",
                      "ArrowDown",
                      "."
                    ].includes(key);
                    if(event.ctrlKey || event.metaKey) {
                        return;
                    }
                    if ((!isDigit && !isSpecialKey )) {
                        event.preventDefault();
                    }
                    if (event.target.value > $scope.spMax) {
                        event.target.value = $scope.spMax;
                    }
                    if($scope.spKeyUp) {
                        $scope.spKeyUp();
                    }
                };
			}
		]
		};
	}]);
})(angular, app);